export default __webpack_public_path__ + "static/media/TarrinSquare.85f111e1.jpg";